import React, { useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,

} from "@mui/material";

const SubmitVivaDialog = ({
  open,
  onClose,
  onConfirm,
  questions = [],
  questionStatus = {},
  isAuto = false,
  autoReason = null,
  isSubmitting = false, // 👈 NEW
}) => {
  const totalQuestions = questions.length;

  const mandatoryQuestions = questions.filter(
    (q) => q.IsMandatory === 1 || q.IsMandatory === "1"
  );
  const totalMandatory = mandatoryQuestions.length;

  const answeredMandatory = mandatoryQuestions.filter(
    (q) => questionStatus[q.Id] === "answered"
  ).length;

  const notAnsweredMandatory = totalMandatory - answeredMandatory;
  const totalAnswered = Object.values(questionStatus).filter(
    (status) => status === "answered"
  ).length;

  useEffect(() => {
    if (open && isAuto && !isSubmitting) {
      const timer = setTimeout(() => {
        onConfirm();
      }, 1500);
      return () => clearTimeout(timer);
    }
  }, [open, isAuto, isSubmitting, onConfirm]);
  return (
    <Dialog
      open={open}

      disableEscapeKeyDown
      maxWidth="sm"
      fullWidth
      onClose={(event, reason) => {
        // 🔒 Force submit → NO closing
        // if (forceSubmit) return;
        if (isAuto || isSubmitting) return;

        // 🔒 Prevent backdrop click
        if (reason === "backdropClick") return;

        // ✅ Normal close
        onClose();
      }}>
      <DialogTitle sx={{ fontWeight: "bold", fontSize: "1.4rem", textAlign: "center" }}>
        Submit Viva Assessment?
      </DialogTitle>

      <DialogContent dividers>

        {isAuto && autoReason === "malpractice" && (
          <Box sx={{ bgcolor: "#ffebee", color: "#c62828", p: 2, borderRadius: 1, mb: 2, textAlign: "center", fontWeight: "bold" }}>
            Maximum malpractice limit exceeded. Your assessment is being submitted automatically.
          </Box>
        )}
        {isAuto && autoReason === "timeout" && (
          <Box sx={{ bgcolor: "#fff3e0", color: "#e65100", p: 2, borderRadius: 1, mb: 2, textAlign: "center", fontWeight: "bold" }}>
            Time is up! Your assessment is being submitted automatically.
          </Box>
        )}

        <Typography variant="body1" sx={{ mb: 3, textAlign: "center" }}>
          Are you sure you want to submit your assessment? Once submitted, you cannot make any changes.
        </Typography>

        <Box sx={{ bgcolor: "#f9f9f9", borderRadius: 2, p: 3 }}>
          <Typography variant="h6" gutterBottom sx={{ color: "#1976d2" }}>
            Assessment Summary
          </Typography>

          <Box sx={{ display: "flex", justifyContent: "space-between", my: 1 }}>
            <span>Total Questions</span>
            <strong>{totalQuestions}</strong>
          </Box>

          <Box sx={{ display: "flex", justifyContent: "space-between", my: 1 }}>
            <span>Attempted</span>
            <strong style={{ color: "#4caf50" }}>{totalAnswered}</strong>
          </Box>

          <Box sx={{ display: "flex", justifyContent: "space-between", my: 1 }}>
            <span>Total Mandatory</span>
            <strong>{totalMandatory} ★</strong>
          </Box>

          <Box sx={{ display: "flex", justifyContent: "space-between", my: 1 }}>
            <span>Mandatory Answered</span>
            <strong style={{ color: answeredMandatory === totalMandatory ? "#4caf50" : "#ff9800" }}>
              {answeredMandatory} / {totalMandatory}
            </strong>
          </Box>

          {notAnsweredMandatory > 0 && (
            <Box
              sx={{
                bgcolor: "#ffebee",
                color: "#c62828",
                p: 2,
                borderRadius: 1,
                mt: 2,
                textAlign: "center",
                fontWeight: "bold",
              }}
            >
              Warning: {notAnsweredMandatory} mandatory question(s) not answered!
            </Box>
          )}
        </Box>
      </DialogContent>

      {/* <DialogActions sx={{ p: 3, justifyContent: "space-between" }}>
        <Button onClick={onClose} variant="outlined" size="large">
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="primary"
          size="large"
          sx={{ minWidth: 140 }}
        >
          Submit Final
        </Button>
      </DialogActions> */}
      <DialogActions sx={{ p: 3, justifyContent: isAuto ? "center" : "space-between" }}>
        {!isAuto && (
          <Button onClick={onClose} variant="outlined" disabled={isSubmitting} size="large">
            Cancel
          </Button>
        )}
        <Button onClick={onConfirm} variant="contained" color="primary" size="large" disabled={isSubmitting} sx={{ minWidth: 160 }}>
          {isSubmitting ? "Submitting..." : "Submit Final"}
        </Button>
      </DialogActions>

    </Dialog>
  );
};

export default SubmitVivaDialog;